import { useQuery } from "@tanstack/react-query";
import { from, translateError } from "@vixio/data";
import { addDaysIso, monthStartIso, todayIso } from "@vixio/ui";

/** Dados dos painéis do Início: ficam fora das telas para que elas carreguem sob demanda. */
export async function countQ(q: PromiseLike<{ count: number | null; error: unknown }>): Promise<number> {
  const r = await q;
  if (r.error) throw translateError(r.error);
  return r.count ?? 0;
}

export function useEnvelopeKpis(orgId: string) {
  const today = todayIso();
  return useQuery({
    queryKey: ["signatures", "kpis", orgId, today],
    queryFn: async () => {
      const base = () => from("signatures", "envelopes").select("id", { count: "exact", head: true }).eq("org_id", orgId);
      const [sent, drafts, completedMonth, expiring] = await Promise.all([
        countQ(base().eq("status", "sent")),
        countQ(base().eq("status", "draft")),
        countQ(base().eq("status", "completed").gte("completed_at", `${monthStartIso(today)}T00:00:00-03:00`)),
        countQ(base().eq("status", "sent").lte("expires_at", `${addDaysIso(today, 7)}T23:59:59-03:00`)),
      ]);
      return { sent, drafts, completedMonth, expiring };
    },
  });
}
